import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  Select,
} from "antd";
import { ContactField  } from '@seims/shared';

import { util } from '@seims/shared';

import commonLookupAPI  from '../../services/commonLookupService';
import { recordError } from "../../utils/logService";

const CreateRepresentative = ({ onCancel, visible, onRepresentativeClick, partnerSummary, rep={}}) => {
  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const formName = "RepresentativeForm";
  const [form] = Form.useForm();
  const { Option } = Select;
  const [titles, setTitle] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [pageTitle, setPageTitle] = useState("Add Representative");

  useEffect(() => {
    getTitles();
  }, [])

  useEffect(() => {
    loadExisting();
  }, [rep, partnerSummary])
  
  const loadExisting = ()=> {
    
    if (!rep.isAdd) {
  
      const selectedTitle = titles.find((person)=>person.key == rep.title);
      setPageTitle("Add / Edit Representative");
      form.setFieldsValue({
        name: rep.name,
        surname: rep.surname,
        email: rep.email,
        title: selectedTitle
      })
    }
    else {
      //setPageTitle("Add Representative");
      form.resetFields();
    }
  }

  const onChangeTitle = (selected) => {
    const title = titles.find((person)=>person.key == selected);
    form.setFieldsValue({
      title: title
    })
  };

  const getTitles =async()=>{
    try {
      const response = await commonLookupAPI.getTitles();
      if (response) {
        const {data} = response;
        setTitle([...data]);
      }
    } catch (error) {
      recordError(error);
    } 
  }

  const handleOfficeNoChange = (value) => {
    form.setFieldsValue({ office: value });
  };

  const handleCellNumberChange = (value) => {
    form.setFieldsValue({ cellphone: value });  
  };
  
  const onSubmit = (values) => {    
    const { title, name, surname, email, cellphone, office } = values;    

    let id = -1;
    if (!util.isEmpty(rep)) {
      id = rep.id
    }

    const representative = {
      fullname: `${title.value} ${name} ${surname}`,
      title: title.key,
      name: name,
      surname: surname,
      email: email,
      cellNumber: cellphone,
      telephoneNumber: office,
      uuid: rep.uuid,
      id: id
    };

    onRepresentativeClick(representative);
    form.resetFields();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
  };

  const onNameBlur = (e)=> {
    const {value, name} = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({[name]: textValue});
  }

  const onPopCancel = () => {
    if (
      form.getFieldValue("title") ||
      form.getFieldValue("name") ||
      form.getFieldValue("surname") ||
      form.getFieldValue("email") ||
      form.getFieldValue("cellphone") ||
      form.getFieldValue("office")
    ) {
      setDisabled(false);
    } else {
      onCancel();
      setDisabled(true);
    }
  };

  return (
    <Modal
      title={pageTitle}
      onCancel={onCancel}
      open={visible}
      maskClosable={true}
      onOk={() =>
        form
          .validateFields()
          .then((res) => {
            form.resetFields();
            onSubmit(res);
          })
          .catch((error) => {
            recordError(error);
          })
      }
      footer={[
        <div key={1} className="modal-footer-buttons">
           <Popconfirm
            key="1p"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button key="1b" onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>

          </Popconfirm>
          <Button
            key="2b"
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
          >
            Save
          </Button>

         
        </div>,
      ]}
    >
      <>
        <div style={{ width: "100%", paddingBottom: 20 }}>
          <Alert
            message={`Partner name: ${partnerSummary.name}`}
            description={`Partner contact: ${partnerSummary.contact}`}
            type="info"
            showIcon
          />
        </div>
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          layout="horizontal"
          onFinish={onSubmit}
        >
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: "Please select a title" }]}
          >
            <Select onChange={onChangeTitle}>
              {titles.map((title) => (
                <Option key={title.key}>{title.value}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="name"
            label="Name"
            rules={[
              { required: true, message: "Please enter representative name" },
            ]}
          >
            <Input name="name" onBlur={onNameBlur} />
          </Form.Item>
          <Form.Item
            name="surname"
            label="Surname"
            rules={[
              {
                required: true,
                message: "Please enter representative surname",
              },
            ]}
          >
            <Input name="surname" onBlur={onNameBlur} />
          </Form.Item>
          <Form.Item name="office" label="Office Number">
            <ContactField
              contactValue={rep.telephoneNumber}
              onContactChange={handleOfficeNoChange}
            />
          </Form.Item>

          <Form.Item
            name="cellphone"
            label="Cellphone No."
            rules={[
              { required: true, message: "Please enter cellphone number" },
            ]}
          >
            <ContactField
              contactValue={rep.cellNumber}
              onContactChange={handleCellNumberChange}
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please enter partner Email",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default CreateRepresentative;
